import React from "react";
import LazyVideo from "../../../../Components/LazyVideo/LazyVideo";

const Video = (props) => {
    const {link, title = 'Video'} = props;
    return <LazyVideo link={link} title={title}/>;
}
export default Video;
